import { createVuetify } from "vuetify";

import "vuetify/styles";
import "@mdi/font/css/materialdesignicons.css"; // Ensure you are using css-loader

export default defineNuxtPlugin((app) => {
    const vuetify = createVuetify({
        ssr: true,
        defaults: {
            VTextField: {
                variant: "outlined",
                density: "compact",
            },
            VTextarea: {
                variant: "outlined",
                density: "compact",
            },
            VSelect: {
                variant: "outlined",
                density: "compact",
            },
        },
    });
    app.vueApp.use(vuetify);
});
